import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import moment from "moment";
import FilterTimeFromTo from "../FilterTimeFromTo";
import { useLocation } from "react-router-dom";
import FilterTextTag2 from "../FilterTextTag2";
import { cloneDeep, isArray, isString } from "lodash";
import { acceptParentheses } from "../../../../../utils/helpers";
import { ACCEPT_REGEX } from "../../../../../utils/constants";
interface IFilterCRThuoc {
  loading?: boolean;
  setCondition: Dispatch<SetStateAction<any>>;
}

function FilterCRThuoc({ loading, setCondition }: IFilterCRThuoc) {
  const location = useLocation();
  const searchObj = new URLSearchParams(location.search);

  const originFilter: { [key: string]: any } = {
    id: searchObj.get("id") || "",
    ten_thuoc: null,
    hoat_chat: null,
    hamluong: null,
    gdklh: null,
    duongdung: null,
    baoche: null,
    nhomthuoc: null,
    cssx: null,
    nuocsx: null,
    quycach: null,
    dvt: null,
    tbmt: null,
    cdt: null,
    soquyetdinh: null,
    slnhathau: "",
    diadiem: null,
    hinh_thuc_lcnt: "",
    han_dung: "",
    ngayquyetdinhFrom: null,
    ngayquyetdinhTo: null,
  };

  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  const handleSearchTags = (tags: any[] | string) => {
    const result: { [key: string]: any } = {};
    const andGroup = [];
    const orGroup = [];
    const notGroup = [];

    let regexAndOr = "";
    let regexNot = "";
    if (isArray(tags)) {
      if (tags?.length > 0) {
        // Phân loại các tag
        for (let i = 0; i < tags.length; i++) {
          const tag = tags[i];
          switch (tag.mode) {
            case "and":
              andGroup.push(tag.value.trim());
              break;
            case "or":
              orGroup.push(tag.value.trim());
              break;
            default:
              notGroup.push(tag.value.trim());
              break;
          }
        }
        if (andGroup?.length > 0 || orGroup?.length > 0) {
          // Nếu tag là loại and
          if (andGroup.length > 0) {
            regexAndOr += `${cloneDeep(andGroup).join(".*")}|${cloneDeep(
              andGroup
            )
              .reverse()
              .join(".*")}`;
          }
          // Nếu tag là loại or
          if (orGroup.length > 0) {
            regexAndOr += `${!!regexAndOr ? "|" : ""}${orGroup.join("|")}`;
          }
          result.$regex = regexAndOr;
          result.$options = "iu";
        }
        // Nếu tag là loại not
        if (notGroup.length > 0) {
          regexNot += `${notGroup.join("|")}`;
        }
        if (!!regexNot) {
          result.$not = {
            $regex: regexNot,
            $options: "iu",
          };
        }
        return result;
      } else {
        return null;
      }
    } else if (isString(tags)) {
      const regex = tags?.split(" ").join(".*");
      return {
        $regex: `^${regex}$`,
        $options: "iu",
      };
    } else {
      return null;
    }
  };

  const handleSearchTagsExcludeSpecialSymbol = (tags: any[] | string) => {
    const result: { [key: string]: any } = {};
    const andGroup = [];
    const orGroup = [];
    const notGroup = [];

    let regexAndOr = "";
    let regexNot = "[^a-zA-Z0-9\\p{L}\\s()]";
    if (isArray(tags)) {
      if (tags?.length > 0) {
        // Phân loại các tag
        for (let i = 0; i < tags.length; i++) {
          const tag = tags[i];
          switch (tag.mode) {
            case "and":
              andGroup.push(acceptParentheses(tag.value.trim()));
              break;
            case "or":
              orGroup.push(acceptParentheses(tag.value.trim()));
              break;
            default:
              notGroup.push(acceptParentheses(tag.value.trim()));
              break;
          }
        }
        if (andGroup?.length > 0 || orGroup?.length > 0) {
          // Nếu tag là loại and
          if (andGroup.length > 0) {
            regexAndOr += `${cloneDeep(andGroup).join(".*")}|${cloneDeep(
              andGroup
            )
              .reverse()
              .join(".*")}`;
          }
          // Nếu tag là loại or
          if (orGroup.length > 0) {
            regexAndOr += `${!!regexAndOr ? "|" : ""}${orGroup.join("|")}`;
          }
          result.$regex = regexAndOr;
          result.$options = "iu";
        }
        // Nếu tag là loại not
        if (notGroup.length > 0) {
          regexNot += `${notGroup.join("|")}`;
        }
        result.$not = {
          $regex: regexNot,
          $options: "iu",
        };
        return result;
      } else {
        return null;
      }
    } else if (isString(tags)) {
      const regex = acceptParentheses(tags)?.split(" ").join(ACCEPT_REGEX);
      return {
        $regex: `^${regex}$`,
        $options: "iu",
        $not: {
          $regex: regexNot,
          $options: "iu",
        },
      };
    } else {
      return null;
    }
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.id) {
      condition.id = filter.id;
    }
    if (filter.ten_thuoc) {
      condition.ten_thuoc = filter.ten_thuoc;
    }
    if (filter.hoat_chat) {
      condition.hoat_chat = filter.hoat_chat;
    }
    if (filter.hamluong) {
      condition.hamluong = filter.hamluong;
    }
    if (filter.gdklh) {
      condition.gdklh = filter.gdklh;
    }
    if (filter.duongdung) {
      condition.duongdung = filter.duongdung;
    }
    if (filter.baoche) {
      condition.baoche = filter.baoche;
    }
    if (filter.nhomthuoc) {
      condition.nhomthuoc = filter.nhomthuoc;
    }
    if (filter.cssx) {
      condition.cssx = filter.cssx;
    }
    if (filter.nuocsx) {
      condition.nuocsx = filter.nuocsx;
    }
    if (filter.quycach) {
      condition.quycach = filter.quycach;
    }
    if (filter.dvt) {
      condition.dvt = filter.dvt;
    }
    if (filter.tbmt) {
      condition.tbmt = filter.tbmt;
    }
    if (filter.cdt) {
      condition.cdt = filter.cdt;
    }
    if (filter.soquyetdinh) {
      condition.soquyetdinh = filter.soquyetdinh;
    }
    if (filter.slnhathau) {
      condition.slnhathau = filter.slnhathau;
    }
    if (filter.diadiem) {
      condition.diadiem = filter.diadiem;
    }
    if (filter.hinh_thuc_lcnt) {
      condition.hinh_thuc_lcnt = filter.hinh_thuc_lcnt;
    }
    if (filter.han_dung) {
      condition.han_dung = filter.han_dung;
    }

    if (filter.ngayquyetdinhFrom || filter.ngayquyetdinhTo) {
      const startDate = moment(filter.ngayquyetdinhFrom)
        .hours(0)
        .minutes(0)
        .seconds(0);
      const endDate = moment(filter.ngayquyetdinhTo)
        .hours(23)
        .minutes(59)
        .seconds(59);
      if (filter.ngayquyetdinhFrom && filter.ngayquyetdinhTo) {
        condition.ngayquyetdinh = { $gte: startDate, $lte: endDate };
      } else if (filter.ngayquyetdinhFrom) {
        condition.ngayquyetdinh = { $gte: startDate };
      } else if (filter.ngayquyetdinhTo) {
        condition.ngayquyetdinh = { $lte: endDate };
      }
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterTimeFromTo
        label="Ngày quyết định"
        defaultTimeFrom={filter.ngayquyetdinhFrom}
        defaultTimeTo={filter.ngayquyetdinhTo}
        onSearch={(times) =>
          setFilter({
            ...filter,
            ngayquyetdinhFrom: times.timeFrom,
            ngayquyetdinhTo: times.timeTo,
          })
        }
      />
      <FilterText
        label="ID (BV)"
        placeholder="Tìm theo ID"
        value={filter.id}
        onSearch={(val) => setFilter({ ...filter, id: val })}
      />
      <FilterTextTag2
        label="Tên thuốc"
        placeholder="Tìm theo tên thuốc"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, ten_thuoc: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Hoạt chất"
        placeholder="Tìm hoạt chất"
        pending={loading}
        toggleClear={toggleClear}
        onSearch={(tags) => {
          setFilter({
            ...filter,
            hoat_chat: handleSearchTagsExcludeSpecialSymbol(tags),
          });
        }}
      />
      <FilterTextTag2
        label="Hàm lượng"
        placeholder="Tìm theo hàm lượng"
        pending={loading}
        toggleClear={toggleClear}
        onSearch={(tags) => {
          setFilter({ ...filter, hamluong: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="GĐKLH hoặc GPNK"
        placeholder="Tìm theo GĐKLH hoặc GPNK"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, gdklh: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Đường dùng"
        placeholder="Tìm theo đường dùng"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, duongdung: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Dạng bào chế"
        placeholder="Tìm theo dạng bào chế"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, baoche: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Nhóm thuốc"
        placeholder="Tìm theo nhóm thuốc"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, nhomthuoc: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Cơ sở sản xuất"
        placeholder="Tìm theo cơ sở sản xuất"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, cssx: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Nước sản xuất"
        placeholder="Tìm theo nước sản xuất"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, nuocsx: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Quy cách"
        placeholder="Tìm theo quy cách"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, quycach: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Đơn vị tính"
        placeholder="Tìm theo đơn vị tính"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, dvt: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Hình thức LCNT"
        placeholder="Tìm theo hình thức LCNT"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, hinh_thuc_lcnt: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Hạn dùng"
        placeholder="Tìm theo hạn dùng"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, han_dung: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Mã TBMT"
        placeholder="Tìm theo mã TBMT"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, tbmt: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Tên CĐT"
        placeholder="Tìm theo tên CĐT"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, cdt: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Số quyết định"
        placeholder="Tìm theo số quyết định"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, soquyetdinh: handleSearchTags(tags) });
        }}
      />
      <FilterText
        label="Nhà thầu tham dự"
        placeholder="Tìm theo số nhà thầu tham dự"
        value={filter.slnhathau}
        onSearch={(val) => setFilter({ ...filter, slnhathau: val })}
      />
      <FilterTextTag2
        label="Địa điểm"
        placeholder="Tìm theo địa điểm"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, diadiem: handleSearchTags(tags) });
        }}
      />
    </WrapperFilter>
  );
}

export default FilterCRThuoc;
